import { component } from 'picoapp';
import delegate from 'delegate';

class FooterNav {
  constructor(el, ctx) {
    this.el = el;
    this.menuItems = el.querySelectorAll('a');
    this.init();
  }

  init() {
    this.menuItems.forEach((item) => {
      this.makeExternal(item);
    });
  }

  makeExternal(link) {
    var url = link.getAttribute('href'),
      host = window.location.hostname.toLowerCase(),
      regex = new RegExp('^(?:(?:f|ht)tp(?:s)?:)?//(?:[^@]+@)?([^:/]+)', 'im'),
      match = url.match(regex),
      domain = (match ? match[1].toString() : url.indexOf(':') < 0 ? host : '').toLowerCase();

    // Same domain
    if (domain != host) {
      link.className = 'outbound';
      link.setAttribute('target', '_blank');
    }
  }
}

// export default MainNav;
export default component((node, ctx) => {
  new FooterNav(node, ctx);
});
